module.exports = __webpack_public_path__ + "static/stone_giant_dreamwalker-d00f0e6f519424ea05b7c18b29a054a2.jpeg";